<h1 mat-dialog-title>Do you want to download Print-to-DDJ?</h1>
<div mat-dialog-content></div>
<div class="form-footer">
    <section>
        <div class="cancel-button-row">
            <div class="confirm-actions right-align" mat-dialog-actions>
                <button mat-button class="secondary" (click)="cancel()">Cancel</button>
                <button mat-button class="primary" (click)="download()">Download</button>
            </div>
        </div>
    </section>
</div>
